export default "__VITE_ASSET__151df2ee__"